angular.module('impactx.retoure').controller('RetoureDetailCtrl', RetoureDetailCtrl);
RetoureDetailCtrl.$inject = [
    '$scope',
    '$routeParams',
    'dataGen',
    '$mdToast',
    'ToolbarService'
];

function RetoureDetailCtrl($scope, $routeParams, dataGen, $mdToast, ToolbarService) {
    var id = $routeParams.id;
    var ctrl = this;

    var getData = function () {
        var params = {
            id: id
        };
        dataGen.getData($scope, params, '/retoure/view').then(function () {
            defineButtons();
        });
    };

    ctrl.sent = function () {
        var params = {
            id: $scope.data.id
        };
        var temp = {};
        return dataGen.getData(temp, params, '/retoure/sent').then(function () {
            if (temp.data) {
                $scope.data.sentDate.value = temp.data.value;
                $scope.data.sentDate.dateValue = temp.data.dateValue;
                $mdToast.show($mdToast.simple()
                    .textContent($scope.trns.sentSuccess)
                    .position("bottom right")
                    .hideDelay(10000));
            }
        });
    };

    var showComments = false;
    ctrl.toggleComments = function () {
        showComments = !showComments;
    };

    $scope.showInternalComments = function () {
        if (!($scope.data && $scope.data.comments)) {
            return false;
        }
        var com = $scope.data.comments.internalComments;
        return com && (com.comments.length > 0 || showComments);
    };

    $scope.showExternalComments = function () {
        if (!($scope.data && $scope.data.comments)) {
            return false;
        }
        var com = $scope.data.comments.externalComments;
        return com && (com.comments.length > 0 || showComments);
    };

    getData();

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.sent,
                action: ctrl.sent,
                type: 'dialogaction',
                condition: canSend
            },
            {
                label: $scope.trns.comment,
                action: ctrl.toggleComments,
                type: 'dialogaction'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canSend() {
        return $scope.data.id > 0 && !($scope.data.sentDate.value || $scope.data.sentDate.dateValue);
    }
}
